import type { NavigationItemConfig } from './workspace-config.types';

/**
 * workspaceConfig가 로드되기 전 또는 null일 때 사용하는 기본 네비게이션
 * BFF definition과 동일한 구조
 */
/** BFF definition과 동일. config null 시 사이드바·FAB 공통 사용 */
export const FALLBACK_NAVIGATION: readonly NavigationItemConfig[] = [
  {
    id: 'home',
    path: '/workspace/home',
    label: '홈',
    description: '대시보드 홈',
    icon: 'Home',
    requiredRole: 'Operator',
    sidebarHiddenForRoles: ['Engineer'],
  },
  {
    id: 'activity',
    path: '/workspace/activity',
    label: '액티비티',
    description: '액티비티',
    icon: 'Timeline',
    requiredRole: 'Operator',
    sidebarHiddenForRoles: ['Engineer'],
  },
  {
    id: 'orders/list',
    path: '/workspace/orders/list',
    label: '주문',
    description: '주문 목록',
    icon: 'Assignment',
    requiredRole: 'Operator',
  },
  {
    id: 'planners',
    path: '/workspace/planners/list',
    label: '플래너',
    description: '플래너 관리',
    icon: 'People',
    requiredRole: 'Operator',
  },
  {
    id: 'my-planner',
    path: '/workspace/my/planner',
    label: '상담지도',
    description: '오늘의 상담 지도',
    icon: 'Map',
    requiredRole: 'Planner',
    sidebarVisibleForRoles: ['Planner'],
  },
  {
    id: 'my-counsels',
    path: '/workspace/my/counsels',
    label: '상담 목록',
    description: '내 상담 목록',
    icon: 'EventNote',
    requiredRole: 'Planner',
    sidebarVisibleForRoles: ['Planner'],
  },
  {
    id: 'my-profile',
    path: '/workspace/my/profile',
    label: '내 정보',
    description: '내 프로필 / 근무일정',
    icon: 'Person',
    requiredRole: 'Planner',
    sidebarVisibleForRoles: ['Planner'],
  },
  {
    id: 'counsel-map',
    path: '/workspace/counsel-map',
    label: '상담지도',
    description: '상담지도',
    icon: 'Map',
    requiredRole: 'Operator',
    sidebarHiddenForRoles: ['Engineer'],
  },
  {
    id: 'moving-items',
    path: '/workspace/moving-items',
    label: '이사 품목',
    description: '이사 품목 스펙 관리',
    icon: 'Category',
    requiredRole: 'Staff',
  },
  {
    id: 'permissions',
    path: '/workspace/settings/permissions',
    label: '권한 설정',
    description: '권한별 노출 화면 설정',
    icon: 'Settings',
    requiredRole: 'Engineer',
  },
  {
    id: 'camera-settings',
    path: '/workspace/settings/camera',
    label: '카메라 설정',
    description: '촬영에 사용할 기본 카메라 선택',
    icon: 'Videocam',
    requiredRole: 'Planner',
    sidebarVisibleForRoles: ['Planner'],
  },
  {
    id: 'my-change-announcements',
    path: '/workspace/my/change-announcements',
    label: '변경 안내',
    description: '바뀐 점을 가이드로 따라 해보기',
    icon: 'Announcement',
    requiredRole: 'Planner',
    sidebarVisibleForRoles: ['Planner'],
  },
  {
    id: 'change-announcement-status',
    path: '/workspace/change-announcements/status',
    label: '변경 안내 이수',
    description: '변경 안내를 끝까지 본 플래너 현황',
    icon: 'AssignmentTurnedIn',
    requiredRole: 'Operator',
    sidebarHiddenForRoles: ['Engineer'],
  },
];
